<template lang="pug">
v-card(flat).fill-height.d-flex.align-center.grey.lighten-4
  v-card-text.text-center
    .text-h5.my-3(
      v-if="tab === 0"
    ) Формирование удостоверений
    .text-h5.my-3(
      v-else-if="tab === 1"
    ) Подписание удостоверений

    p Выбрано всего
      strong  {{ item.length }}
    .my-5
      v-btn.ml-auto(
        color="secondary"
        depressed
        rounded
        x-large
        :disabled="!item.length"
        @click="handleBtn"
      )
        //- loading
        span {{ tab ? 'Подписать' : 'Сформировать'}}
        v-icon(right) mdi-checkbox-marked-circle-outline

  portal(
    v-if="tab === 1"
    to="sign.dialog" v-slot="{ attrs, close }"
  )
    v-card.sdo-card
      v-list-item
        v-list-item-title.tex-body-1 Массовая подпись удостоверения
        v-list-item-action
          v-btn(icon @click="close"): v-icon mdi-close
      v-card-title
      v-card-text
        certificate-sign(
          :selected="item"
          :unSelected="unSelected"
          :isUnselect="attrs.isUnselect"
          :queryParams="queryParams"
          @sign="$emit('onMassSign')"
        )
</template>
<script>
import CertificateSign from './CertificateSign.vue';

export default {
  components: {
    CertificateSign,
  },
  props: {
    item: { type: Array, required: true },
    tab: { type: Number, required: true },
    unSelected: { type: Array, default: () => [] },
    queryParams: { type: Object, default: () => {} },
  },
  data() {
    return {};
  },
  methods: {
    closeSign() {
      this.$emit('onMassSign');
    },
    handleBtn() {
      const type = this.tab ? 'dialog-portal' : 'form-controller';
      const selectedLength = this.item.length;
      const notEmptySelectedLength = Object.values(this.item).length;
      const isUnselect = notEmptySelectedLength !== selectedLength || !!this.unSelected.length;
      const attrs = this.tab ? {
        dialogProps: { maxWidth: 800 },
        inputValue: 'sign',
        isUnselect,
      } : {
        title: 'Формирование удостоверений',
        message: `Будет сформировано ${this.item.length} удостоверений`,
        fields: [{
          component: 'v-text-field',
          text: 'Введите серийный номер',
          value: 'serial',
          rules: 'required|length:4',
          component_attrs: {
            counter: 4,
            filled: true,
            rounded: true,
          },
        }],
        method: ({ data }) => {
          const payload = {
            ...data,
            prior_record_user_ids: isUnselect ? [] : this.item,
            exclude_prior_record_user_ids: this.unSelected,
          };
          return this.$api.diploma.createDiplomas(
            payload,
            { params: this.queryParams },
          ).then(() => {
            this.$emit('unSelect');
            this.$toasted.success('Успешно');
            this.$modals.close();
          });
        },
      };
      this.$modals.show(type, attrs);
    },
  },
};
</script>
